import { useCallback } from "react";
import { useLocation } from "react-router";

export const useIsActive = (): ((path: string, startsWith?: boolean) => () => boolean) => {
  const location = useLocation();
  return useCallback(
    (path, startsWith) => () =>
      startsWith ? location.pathname.startsWith(path) : location.pathname === path,
    [location.pathname],
  );
};
